import {lazy} from 'react'

const OrganizationPage = lazy(() => import('organization/organization-page'))

export default OrganizationPage
